// Section 19 effects over time (stream E2): effects past their last season are dropped (those
// ending this season stay until the next, as the decay phase still reads them); effects that
// yield stock each season (a developed herb patch) yield it; seed saved from a blighted harvest is
// worth half; a blight that lingers in the soil is announced the season before it returns; old
// warnings are dropped.
import { effectActive } from '../../core/content-helpers';
import type { PhaseContext } from '../../core/types';
import { addStock } from '../shared/stocks';

export function upkeep(ctx: PhaseContext): void {
  const d = ctx.draft;
  const turn = ctx.season.turn;
  d.activeEffects = d.activeEffects.filter((e) => e.untilTurn >= turn);
  for (const e of d.activeEffects) {
    if (e.params.returns === 1 && e.sinceTurn === turn + 1)
      ctx.report.add({ kind: 'event', eventId: e.eventId, params: { variant: 'returns' } });
    if (!effectActive(ctx.live, e)) continue;
    const medicine = e.params.medicinePerSeason;
    if (medicine !== undefined && medicine > 0) addStock(ctx, 'medicine', medicine, 'production');
    const seedMul = e.params.seedMul;
    if (seedMul !== undefined && e.untilTurn === turn && d.seedReserved > 0)
      d.seedReserved = Math.max(0, d.seedReserved * seedMul);
  }
  d.foreshadows = d.foreshadows.filter((f) => f.targetTurn >= turn);
}
